import React from 'react';

const ArchitectureDiagram = () => {
    return (
        <section className="feature-section architecture-section">
            <div className="container">
                <h2 className="section-title center">HOW PASSIVEGUARD WORKS</h2>
                <p className="section-description center" style={{ marginBottom: '4rem' }}>
                    Cloud-native architecture designed for infinite scale and millisecond latency.
                </p>
                
                {/* Simplified CSS-based flowchart */}
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap', gap: '20px' }}>
                    
                    {/* Step 1 */}
                    <div style={{ textAlign: 'center', width: '200px' }}>
                        <div style={{ border: '1px solid var(--gh-border-active)', background: 'var(--gh-bg)', borderRadius: '50%', width: '100px', height: '100px', display: 'grid', placeItems: 'center', margin: '0 auto 20px', fontSize: '2rem' }}>
                            📡
                        </div>
                        <h4 style={{ color: 'var(--gh-text)' }}>Collect</h4>
                        <p style={{ color: 'var(--gh-text-muted)', fontSize: '0.9rem' }}>Agents, logs, and traffic</p>
                    </div>

                    <div style={{ color: 'var(--gh-text-muted)', fontSize: '2rem' }}>-&gt;</div>

                    {/* Step 2 */}
                    <div style={{ textAlign: 'center', width: '200px' }}>
                         <div style={{ border: '1px solid var(--gh-border-active)', background: 'var(--gh-bg)', borderRadius: '50%', width: '100px', height: '100px', display: 'grid', placeItems: 'center', margin: '0 auto 20px', fontSize: '2rem' }}>
                            🧠
                        </div>
                        <h4 style={{ color: 'var(--gh-text)' }}>Analyze</h4>
                        <p style={{ color: 'var(--gh-text-muted)', fontSize: '0.9rem' }}>AI correlation engine</p>
                    </div>

                    <div style={{ color: 'var(--gh-text-muted)', fontSize: '2rem' }}>-&gt;</div>

                     {/* Step 3 */}
                     <div style={{ textAlign: 'center', width: '200px' }}>
                         <div style={{ border: '1px solid var(--gh-border-active)', background: 'var(--gh-bg)', borderRadius: '50%', width: '100px', height: '100px', display: 'grid', placeItems: 'center', margin: '0 auto 20px', fontSize: '2rem' }}>
                            🛡️
                        </div>
                        <h4 style={{ color: 'var(--gh-text)' }}>Respond</h4>
                        <p style={{ color: 'var(--gh-text-muted)', fontSize: '0.9rem' }}>Auto-remediation and alerts</p>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default ArchitectureDiagram;
